import { useEffect, useState } from 'react'

import { NotificationController } from 'core-components/library/popup'

import { fetchEngagementPredictionByPartnerId } from '../api/fetchEngagementPredictionByPartnerId'

import { EngagementPrediction } from './types'

interface UseEngagementOptions {
  showNotificationOnError?: boolean
}

export const useEngagementPrediction = (
  partnerId: string | null,
  options?: UseEngagementOptions
) => {
  const [data, setData] = useState<EngagementPrediction | null>(null)
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(Boolean(partnerId))

  useEffect(() => {
    if (!partnerId) {
      setData(null)
      return
    }

    let isMounted = true
    setIsLoading(true)

    fetchEngagementPredictionByPartnerId(partnerId)
      .then((result) => {
        if (isMounted) {
          setData(result)
        }
      })
      .catch(() => {
        if (isMounted) {
          setIsError(true)

          if (options?.showNotificationOnError) {
            NotificationController.showError({
              message: 'An error occurred while fetching Engagement Prediction data.',
            })
          }
        }
      })
      .finally(() => {
        if (isMounted) {
          setIsLoading(false)
        }
      })

    return () => {
      isMounted = false
    }
  }, [partnerId, options?.showNotificationOnError])

  return {
    data,
    isLoading,
    isError,
  }
}
